import styled from 'astroturf/react';
import Button from 'src/components/Button';

const Block = styled('div')`
  padding: 20px 20px 20px 40px;
  background-color: var(--white);
  border-right: 1px solid var(--ph-gray-50);
  height: 100%;
`;

const SmallButton = styled(Button)`
  font-size: var(--ph-text-sm) !important;
  padding: 5px 10px !important;
  min-width: 0;
  height: 30px; 
`;
  
const Row = styled('div')`
  display: flex;
  flex-direction: row;
  page-break-inside: avoid;
  break-inside: avoid;

  & > div {
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color: var(--black);
    padding: 5px 10px;
  }

  &.header > div {
    background-color: var(--ph-dark-blue-500);
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: var(--white);
    text-align: left;
    border: 1px solid rgba(var(--white-rgb), 0.2);
    border-bottom: 0;
  }

  &.section > div {
    color: var(--black);
    border: 0;
  }
`;

const Cell = styled('div')`
  flex: 1;

  &:nth-child(1) {
    flex: 0 0 16%;
  }

  &:nth-child(2) {
    flex: 0 0 36%;
    word-break: break-all;
  }

  &:nth-child(3) {
    flex: 0 0 18%;
  }

  &:only-child {
    flex: 1;
  }

  &.label {
    color: var(--ph-gray-500);
  }
`;

export default {
  Block,
  Cell,
  Row,
  SmallButton
};
